import React from "react";
import InputComponent from "../../UI/InputComponent/InputComponent";
import Row from "../WrapperComponents/Row";
import Col from "../WrapperComponents/Col";
import DatePicker from "../../UI/DatePicker/DatePicker";
import Select from "react-virtualized-select";
import ColDynamic from "../WrapperComponents/ColDynamic";
import "./AddressDataResidency.css";

const AddressDataResidency = (props) => {
  const { address } = props.parentState.newFormData;
  const { countryList } = props.parentState;
  const { countyList } = props.parentState;
  const { cityAndMuncipalityList } = props.parentState;
  const { districtList } = props.parentState;
  const { userData } = props.parentState.newFormData;
  const { parentState } = props;
  const { sifDrzave, sifZupanije, sifGrdOpc, sifNaselja } = address;

  const mappedCityAndMuncipalityList = cityAndMuncipalityList.map(
    (element) => element.gradoviOpcine[0]
  );

  const mappedDistrictList = districtList.map((element) => element.naselja[0]);

  const style = { borderColor: "red" };

  return (
    <div className="form-group">
      <Row>
        <ColDynamic className="col-lg-4 mb-16">
          <>
            <label>Država</label>
            <Select
              noResultsText={"Nema rezultata"}
              style={
                (props.required &&
                  props.parentState.error &&
                  address.sifDrzave.length < 1 &&
                  style) ||
                null
              }
              className="error-test"
              placeholder="Odaberi državu"
              options={countryList}
              onChange={(selectValue) =>
                props.autocompleteCountryHandler(selectValue, {
                  formGroup: "address",
                  value: "sifDrzave",
                  code: "sifDrzave",
                  name: "nazivDrzave",
                })
              }
              labelKey="nazivKratki"
              valueKey="sifDrzave"
              value={address.sifDrzave}
            />
          </>
        </ColDynamic>

        <Col>
          {sifDrzave != "191" && sifDrzave !== "" ? (
            <InputComponent

              onChange={props.userInputHandler}
              objData={{ group: "address" }}
              value={address.nazZupanije}
              id="nazZupanije"
              name="nazZupanije"
              controlLabel={"Naziv županije"}
            />
          ) : (
            <>
              <label>Naziv županije* </label>
              <Select
                noResultsText={"Nema rezultata"}
                style={
                  (props.required &&
                    props.parentState.error &&
                    address.sifZupanije.length < 1 &&
                    style) ||
                  null
                }
                placeholder="Odaberi županiju"
                disabled={props.disableCounty}
                options={countyList}
                onChange={(selectValue) =>
                  props.autocompleteCountyHandler(selectValue, {
                    formGroup: "address",
                    value: "sifZupanije",
                    code: "sifZupanije",
                    name: "nazZupanije",
                  })
                }
                labelKey="nazZupanije"
                valueKey="sifZupanije"
                value={address.sifZupanije}
              />
            </>
          )}
        </Col>
      </Row>

      <Row>
        {sifDrzave != 191 && sifDrzave !== "" ? (
          <>
            <Col>
              <InputComponent

                onChange={props.userInputHandler}
                objData={{ group: "address" }}
                value={address.nazGrdOpc}
                id="nazGrdOpc"
                name="nazGrdOpc"
                controlLabel={"Naziv grada/općine"}
              />
            </Col>
            <Col>
              <InputComponent
                required={props.required}
                style={
                  props.required &&
                  props.parentState.error &&
                  address.nazNaselja.length < 1 &&
                  "red"
                }
                onChange={props.userInputHandler}
                objData={{ group: "address" }}
                value={address.nazNaselja}
                id="nazNaselja"
                name="nazNaselja"
                controlLabel={"Naziv mjesta"}
              />
            </Col>
          </>
        ) : (
          <>
            <ColDynamic className="col-lg-4 mb-16">
              <>
                <label>Naziv grada ili općine* </label>
                <Select
                  noResultsText={"Nema rezultata"}
                  style={
                    (props.required &&
                      props.parentState.error &&
                      address.sifGrdOpc.length < 1 &&
                      style) ||
                    null
                  }
                  placeholder="Odaberi grad ili općinu"
                  disabled={props.disableCity}
                  options={mappedCityAndMuncipalityList}
                  onChange={(selectValue) =>
                    props.autocompleteCityHandler(selectValue, {
                      formGroup: "address",
                      value: "sifGrdOpc",
                      code: "sifGrdOpc",
                      name: "nazGrdOpc",
                    })
                  }
                  labelKey="nazGrdOpc"
                  valueKey="sifGrdOpc"
                  value={address.sifGrdOpc}
                />
              </>
            </ColDynamic>
            <Col>
              <>
                <label>Naziv mjesta* </label>
                <Select
                  noResultsText={"Nema rezultata"}
                  style={
                    (props.required &&
                      props.parentState.error &&
                      address.sifNaselja.length < 1 &&
                      style) ||
                    null
                  }
                  placeholder="Odaberi mjesto"
                  disabled={props.disableDistrict}
                  options={mappedDistrictList}
                  onChange={(selectValue) =>
                    props.autocompleteDistrictHandler(selectValue, {
                      formGroup: "address",
                      value: "sifNaselja",
                      code: "sifNaselja",
                      name: "nazNaselja",
                    })
                  }
                  labelKey="nazNaselja"
                  valueKey="sifNaselja"
                  value={address.sifNaselja}
                />
              </>
            </Col>
          </>
        )}
      </Row>
      <Row className="row align-self-start">
        <Col>
          <InputComponent
            required
            style={
              props.required &&
              props.parentState.error &&
              address.brPoste.length < 1 &&
              "red"
            }
            onChange={props.userInputHandler}
            objData={{ group: "address" }}
            value={address.brPoste}
            id="brPoste"
            name="brPoste"
            controlLabel={"Poštanski broj"}
          />
        </Col>
        <Col>
          <InputComponent
            required
            style={
              props.required &&
              props.parentState.error &&
              address.ulicaKbr.length < 1 &&
              "red"
            }
            onChange={props.userInputHandler}
            objData={{ group: "address" }}
            value={address.ulicaKbr}
            id="ulicaKbr"
            name="ulicaKbr"
            controlLabel={"Ulica i kućni broj"}
          />
        </Col>
      </Row>

      <Row>
        <ColDynamic className="col-lg-8 regbr-style">
          {props.parentState.update && (
            <InputComponent
              disabled
              required
              style={
                props.required &&
                props.parentState.error &&
                userData.regBroj.length < 1 &&
                "red"
              }
              onChange={props.userInputHandler}
              objData={{ group: "userData" }}
              value={userData.regBroj}
              id="regBroj"
              name="regBroj"
              controlLabel={"Registarski broj"}
            ></InputComponent>
          )}
        </ColDynamic>
      </Row>
    </div>
  );
};

export default AddressDataResidency;
